import { useMemo } from 'react'

import type { HelpCardRecord } from './data'
import type { HelpFilterKey, HelpFilters } from './useFilters'

const satisfiesFilter = (record: HelpCardRecord, filters: HelpFilters, filter: HelpFilterKey) => {
  const filterValue = filters[filter]
  const recordKey = `${filter}s` as const
  const recordAttributes = record[recordKey]

  return filterValue === null || (recordAttributes as string[]).includes(filterValue)
}

const useFilteredData = (data: HelpCardRecord[], filters: HelpFilters) => {
  return useMemo(
    () =>
      data.filter(
        (record) =>
          satisfiesFilter(record, filters, `contentType`) &&
          satisfiesFilter(record, filters, `role`) &&
          satisfiesFilter(record, filters, `topic`)
      ),
    [data, filters]
  )
}

export default useFilteredData
